<template>
    <div class="land-commerce">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.commerce_section_title_img + ')'"></div>
            <!-- <h2>{{salesCard.commerce_section_title}}</h2> -->
            <h2 v-html="salesCard.commerce_section_title"></h2>
        </div>
        <div class="container">
            <div class="land-commerce-column-container">
                <div class="col-left">
                    <div class="section-title" v-if="!isMobileChecker">
                        <h2 v-html="salesCard.commerce_section_title"></h2>
                    </div>
                    <div class="desc-html" v-html="salesCard.commerce_desc"></div>
                    <div class="desc-icons-list list-six" :class="'desc-icons-' + projectNameG">
                        <ul>
                            <li v-for="(item, index) in salesCard.commerce_icon_list" :key="index">
                                <div class="icon-img">
                                    <img :src="item.icon" alt="">
                                </div>
                                <div class="icon-desc">
                                    <p v-html="item.desc"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-right" v-if="!isMobileChecker">
                    <div class="col-img">
                        <img :src="salesCard.commerce_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-land-commerce',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-commerce.scss';
    @import '@/styles/components/sales/respond/land-commerce-respond.scss';
</style>